import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig, loadCookieScripts, loadGTMScript } from './app/app.config';
import { AppComponent } from './app/app.component';

try {
  await bootstrapApplication(AppComponent, appConfig);
  loadGTMScript();
  loadCookieScripts();
} catch (err) {
  console.error(err);
}
